const addErrorSnackbarInterceptors = (client, checkAndSendSnackbarError) => {
  client.interceptors.response.use(
    response => response,
    error => {
      checkAndSendSnackbarError(error);
      return Promise.reject(error);
    },
  );

  return client;
};

export default addErrorSnackbarInterceptors;
